/**
 * "Vì sao gọi vốn lần đầu khó" trên trang chủ (27/10/2026, học từ mục nỗi đau
 * của FundingFactory): kể bằng giao diện giả thay vì đoạn văn. Ba cảnh founder
 * lần đầu nhận ra mình: hộp thư gửi đi không ai trả lời, file Excel theo dõi
 * quỹ toàn dấu hỏi, deck sửa tới bản thứ chín mà vẫn không biết thiếu gì.
 *
 * Tên quỹ là A, B, C... và mọi con số là minh hoạ. Không dùng tên quỹ thật:
 * đặt tên thật vào cảnh "không trả lời" là nói sai về họ.
 */
const THU = [
  ["Quỹ A", "Giới thiệu startup, vòng pre-seed", "Không trả lời, 21 ngày"],
  ["Quỹ B", "Nhắc lại: deck của chúng tôi", "Không trả lời, 14 ngày"],
  ["Quỹ C", "Xin 15 phút trao đổi?", "Sai giai đoạn"],
  ["Quỹ D", "Deck bản 9 đính kèm", "Không đúng ngành"],
];
const EXCEL = [
  ["Quỹ A", "Seed?", "Gửi lại"],
  ["Quỹ B", "??", "Chờ"],
  ["Quỹ C", "Series A", "Sai vòng"],
  ["Quỹ E", "??", "Nhờ người quen?"],
];
const DECK = [
  "Định giá bao nhiêu là hợp lý?",
  "Gọi 3 tỷ có đủ tới vòng sau?",
  "Vesting có cần ký trước?",
  "Slide traction đã đủ chưa?",
];

export default function NoiDauGoiVon() {
  return (
    <section className="ndv section-space" aria-labelledby="ndv-tieu-de">
      <div className="ndv-dau">
        <p className="eyebrow">VÌ SAO GỌI VỐN LẦN ĐẦU KHÓ</p>
        <h2 id="ndv-tieu-de">Ý tưởng không thiếu. Thiếu là biết mình đang đứng ở đâu.</h2>
        <p className="lead">Người gọi vốn lần đầu thường mất vài tháng gửi hồ sơ cho nơi không hợp, theo dõi bằng file rời rạc, và sửa deck mà không biết nhà đầu tư sẽ hỏi gì.</p>
      </div>

      <div className="ndv-luoi">
        <article className="ndv-the">
          <div className="ndv-canh" aria-hidden="true">
            <div className="ndv-thu-dau"><b>Đã gửi</b><span>30 email, 2 trả lời</span></div>
            <ul className="ndv-thu">
              {THU.map(([ten, tieuDe, tt]) => (
                <li key={ten}>
                  <i>{ten.slice(-1)}</i>
                  <span><strong>{ten}</strong>{tieuDe}</span>
                  <em>{tt}</em>
                </li>
              ))}
            </ul>
          </div>
          <h3>Gửi nhầm chỗ</h3>
          <p>Quỹ đúng có tồn tại, nhưng hồ sơ đi tới nơi sai giai đoạn, sai ngành hay sai quy mô séc. Mỗi email không hồi âm là vài tuần chờ.</p>
        </article>

        <article className="ndv-the">
          <div className="ndv-canh" aria-hidden="true">
            <div className="ndv-excel-ten">danh-sach-quy-v5-FINAL.xlsx</div>
            <table className="ndv-excel">
              <thead><tr><th>Quỹ</th><th>Vòng</th><th>Trạng thái</th></tr></thead>
              <tbody>
                {EXCEL.map(([a, b, c]) => <tr key={a}><td>{a}</td><td>{b}</td><td>{c}</td></tr>)}
              </tbody>
            </table>
          </div>
          <h3>Không biết quỹ cần gì</h3>
          <p>Khẩu vị đầu tư nằm rải rác trên web của quỹ, bài báo và lời kể. Bảng theo dõi đầy dấu hỏi, nên khó biết nên ưu tiên nơi nào.</p>
        </article>

        <article className="ndv-the">
          <div className="ndv-canh" aria-hidden="true">
            <div className="ndv-deck-ten">pitch-deck-ban-9.pdf</div>
            <ul className="ndv-deck">
              {DECK.map((c) => <li key={c}><i>?</i>{c}</li>)}
            </ul>
          </div>
          <h3>Sửa deck mà không biết thiếu gì</h3>
          <p>Deck qua chín bản, nhưng chưa ai chỉ ra con số nào còn trống hay câu hỏi nào nhà đầu tư chắc chắn sẽ hỏi.</p>
        </article>
      </div>
      <p className="ndv-ghi-chu">Ví dụ minh hoạ, tên quỹ và số liệu không có thật.</p>
    </section>
  );
}
